<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3>{{ 'STEPS.FILTER_CTA' | translate }}</h3>
    <form
      [formGroup]="unpaid_filter_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.ORDER_ID_COLUMN_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="order_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STEPS.ID_COLUMN_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="step_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.BUYER_COLUMN_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="buyer_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.COMPANY_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="company_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.STORE_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="store_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="status"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="recovered_status">
            {{ getUnpaidStatusLabel(recovered_status) | translate }}
          </mat-option>
          <mat-option [value]="expired_status">
            {{ getUnpaidStatusLabel(expired_status) | translate }}
          </mat-option>
          <mat-option [value]="pending_status">
            {{ getUnpaidStatusLabel(pending_status) | translate }}
          </mat-option>
          <mat-option [value]="canceled_status">
            {{ getUnpaidStatusLabel(canceled_status) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.QINETIC_ID_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="qinetic_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'UNPAID.DAYS_UNPAID_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="unpaid_days"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'UNPAID.UNPAID_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="unsolved"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="yes">
            {{ 'GENERAL.YES_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="no">
            {{ 'GENERAL.NO_LABEL' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'UNPAID.UNPAID_FROM_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="created_from"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="from_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="from_picker"></mat-datepicker-toggle>
        <mat-datepicker #from_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'UNPAID.UNPAID_TO_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="created_to"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="to_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="to_picker"></mat-datepicker-toggle>
        <mat-datepicker #to_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STEPS.FILTER_DUE_DATE_FROM_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="due_date_from"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="due_date_from_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="due_date_from_picker"></mat-datepicker-toggle>
        <mat-datepicker #due_date_from_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STEPS.FILTER_DUE_DATE_TO_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="due_date_to"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="due_date_to_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="due_date_to_picker"></mat-datepicker-toggle>
        <mat-datepicker #due_date_to_picker></mat-datepicker>
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
